import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import CustomSpinner from "../../components/infrastructure/customSpinner"

interface ILogOutProps extends IBaseProps {
}
interface ILogOutStates extends IBaseStates {
}
export class LogOut extends BaseComponent<ILogOutProps, ILogOutStates> {
    constructor(props: ILogOutProps) {
        super(props)
        this.state = {
            loading: true,
            isAuthorized: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
        };
    }
    componentDidMount() {
        super.componentDidMount()
        this.logout();
    }
    logout = async () => {
        await this.callApi({
            url: "user/logout",
            onComplete: () => {
                window.location.replace("/");
            }
        })
    }
    virtualRender() {
        return (<CustomSpinner />);
    }
}